import { ICaseCloseRepository } from '../ports/outbound/ICaseCloseRepository';

export class CloseCaseUseCase {
    constructor(
        private readonly caseCloseRepository: ICaseCloseRepository
    ) { }

    async execute(
        everifyCaseId: string,
        reasonCode: string,
        reasonDescription: string
    ): Promise<void> {
        return this.caseCloseRepository.closeCase(everifyCaseId, reasonCode, reasonDescription);
    }
}
